// src/pages/Premixes.js
import React from 'react';
import ProductCategoryTemplate from '../components/templet/ProductCategoryTemplate';
import image2 from '../assets/images/product/image-2.jpg';
import image3 from '../assets/images/product/image-3.jpg';
import image4 from '../assets/images/product/image-4.jpg';
import image5 from '../assets/images/product/image-5.jpg';
import image6 from '../assets/images/product/image-6.jpg';
import image7 from '../assets/images/product/image-7.jpg';
import image8 from '../assets/images/product/image-8.jpg';
import image9 from '../assets/images/product/image-9.jpg';
import image10 from '../assets/images/product/image-10.jpg';
import premixes from '../assets/images/category/premixes.jpg';

const Premixes = () => {
  const products = [
    {
      name: "Cake Premixes",
      category: "PREMIXES",
      description: "High-tech Premixes: GRR—the low-cost, ultra-high-performing solution to all your Cake Premixing needs. Get consistent results with minimal effort. Perfect for scaled-up bakeries looking for efficiency without compromising on quality.",
      features: [
        "High-rise sponge cakes (±6%) : GRR's spring-back cake premixes are easy to use with eggs.",
        "High-rise BAKERY Mix: premixes with high performance from frozen storage.",
        "High-rise BAKERY Mix (±6%) : Shelf-stable Bakery Cake-base-mix with improved taste and texture."
      ],
      image: "/assets/images/cake-premix.jpg"
    },
    {
      name: "Pastry & Bread Premixes",
      category: "PREMIXES",
      description: "Complete solutions for artisan breads, croissants, Danish pastries, and more. Our premixes ensure consistent quality while simplifying your production process.",
      features: [
        "Artisan Premix: Pre-mix for artisan-styled breads with excellent oven-spring.",
        "Danish Premix: High-fat laminated pastry premix with superior flake and layers.",
        "Croissant Mix: Ready-to-use premix for perfect croissants with rich, buttery flavor.",
        "Bun & Roll Premix: All-purpose premix for soft buns and rolls with extended shelf-life."
      ],
      image: "/assets/images/pastry-premix.jpg"
    },
    {
      name: "Specialty & Dessert Mixes",
      category: "PREMIXES",
      description: "Premium mixes for specialty applications including muffins, brownies, cookies, and dessert bases. Perfect for expanding your product range with minimal R&D.",
      features: [
        "Brownie Mix (GF) : Rich, fudgy brownies with no compromises on taste or texture.",
        "Muffin Mix: Versatile base for fruit, chocolate, or savory muffins.",
        "Cookie Mix: Easy-to-use mix for various cookie types with consistent results.",
        "Dessert Base: Adaptable premix for multiple dessert applications."
      ],
      image: "/assets/images/specialty-mix.jpg"
    }
  ];

  const relatedCategories = [
    {
      title: "Bread Improvers & Dough Conditioners",
      description: "Boost volume, improve texture, extend shelf-life with zero guesswork.",
      itemCount: 12,
      image:image2,
      link: "/products/bread-improvers"
    },
    {
      title: "Shelf-Life Enhancers & Preservatives",
      description: "Keep your baked goods fresher, safer, and quality-assured for longer.",
      itemCount: 10,
      image: image3,
      link: "/products/shelf-life"
    },
    {
      title: "Emulsifiers & Texture Improvers",
      description: "Smoother texture, softer crumbs, longer shelf life—made effortless.",
      itemCount: 8,
      image: image4,
      link: "/products/emulsifiers"
    },
    {
      title: "Leavening Agents (Raising Agents)",
      description: "Rise to new heights—perfect volume and texture every time.",
      itemCount: 13,
      image: image5,
      link: "/products/leavening"
    },
    {
      title: "Specialty Enzymes",
      description: "Transform your dough quality and reduce dependency on chemical additives.",
      itemCount: 17,
      image: image6,
      link: "/products/enzymes"
    },
    {
      title: "Other Ingredients: Starches, Gums, Flavors",
      description: "The finishing touch—functional bakery ingredients.",
      itemCount: 20,
      image: image7,
      link: "/products/other-ingredients"
    },
    {
      title: "Quality Assurance",
      description: "Consistent Quality. Guaranteed. Every Batch. Every Time.",
      itemCount: null,
      image: image8,
      link: "/quality"
    },
    {
      title: "View All",
      description: "Explore our complete range of bakery ingredients.",
      itemCount: null,
      image:image9,
      link: "/products"
    }
  ];

  return (
    <ProductCategoryTemplate
      title="Premixes & Concentrates"
      description="Simplify your process and ensure consistent results—every single time. Our premium premixes are designed to meet the demands of modern bakeries, from small artisan shops to large-scale production facilities."
      heroImage= {premixes}
      products={products}
      relatedCategories={relatedCategories}
    />
  );
};

export default Premixes;